<template>
  <div class="content-theme">
      <div class="content-theme-l">
          <slot name="content-theme-l"></slot>
      </div>
      <div class="content-theme-r">
          <slot name="content-title-r"></slot>
      </div>
  </div>
</template>

<script>
export default {
    name:"ContentTitle"
}
</script>

<style scoped>
    .content-theme{
        height: 95px;
        line-height: 95px;
    }
    .content-theme-l{
        float: left;
    }
    .content-theme-r{
        float: right;
    }
</style>